import { SubjectMetaTimerstatus } from '@surveycake/logic-engine';
import {
  useSubjectId,
  useSubjectMeta,
  UseSubjectMetaSelector
} from '@surveycake/react-logic-engine';

const timerStatusSelector: UseSubjectMetaSelector<
  SubjectMetaTimerstatus
> = meta => meta.timerStatus;

export function useTimerStatus() {
  const id = useSubjectId();
  return useSubjectMeta(id, timerStatusSelector);
}
